module.exports = __webpack_public_path__ + "img/selected1-min.0e15d67a.png";